var exports = {
  "kL": "x127c5a35--a4f745--container",
};

module.exports = exports;
